<template>
  <div>
    <div
      class="form-detail"
      v-if="dataContract.lstAppendixLiquidDates && dataContract.lstAppendixLiquidDates.length > 0"
    >
      <h1>Biên bản thanh lý</h1>
      <div
        class="table-responsive"
        v-for="(item, index) in dataContract.lstAppendixLiquidDates"
        :key="index"
      >
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Mã biên bản</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Số lượng thiết bị</th>
              <th scope="col" class="text-right">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                  <b>Ngày tạo :</b>
                  {{
                    item.dateCreatedAppendixDTO
                      ? item.dateCreatedAppendixDTO
                      : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                  }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' || item.state === 'REJECTED_SA') &&
                    (item.dateSignAppendixDTO || item.dateSign)
                  "
                >
                  <b>Ngày ký :</b>
                  {{
                    item.dateSignAppendixDTO ? item.dateSignAppendixDTO : item.dateSign | formatDate
                  }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED'">
                  <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                </p>
              </td>
              <td class="text-left">
                {{
                  item.numDevices ? item.numDevices : item.appendixLiquidDate.dataLiquidDates.length
                }}
              </td>
              <td align="right">
                <span class="badge" v-bind:class="[item.state ? item.state : '']">{{
                  item.state ? item.state : '' | mapTextStatus(listStatusContract)
                }}</span>
                <div
                  v-if="
                    item.state && (item.state === 'REJECTED_SA' || item.state === 'REJECTED_MA')
                  "
                >
                  <p
                    class="form-control-plaintext f12 text-center"
                    v-if="
                      item.reasonRejected && item.reasonRejected[item.reasonRejected.length - 1]
                    "
                  >
                    Lý do: &nbsp;
                    {{
                      item.reasonRejected ? item.reasonRejected[item.reasonRejected.length - 1] : ''
                    }}
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <table class="table table-bordered">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" class="text-left">Tên thiết bị</th>
                      <th scope="col" class="text-left">Mã serial</th>
                      <th scope="col" class="text-right">Tình trạng sử dụng</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(itemm, index) in item.appendixLiquidDate.dataLiquidDates"
                    :key="index"
                  >
                    <tr class="table-row">
                      <td class="text-left">{{ itemm.device.name }}</td>
                      <td class="text-left">
                        {{ itemm.device.serialNumber }}
                      </td>
                      <td align="right">
                        {{ itemm.status }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
        showFeeCredit: false,
        dataTariff: [],
      }
    },
    methods: {
      showFeeModalCredit(data) {
        this.showFeeCredit = true
        this.dataTariff = data
      },
    },
  }
</script>

<style scoped>
  /*Modal Bieu phi*/
  .modal-dialog {
    max-width: 60%;
    overflow-x: auto;
    margin: 0 auto;
  }
  .modal-body {
    width: 100%;
  }
  @media screen and (max-width: 410px) {
    .modal-dialog {
      margin: 0 7%;
      max-width: 76%;
    }
  }
</style>
